import React from "react";
import millify from "millify";
import { Typography, Row, Col, Statistic } from "antd";
import { Link } from "react-router-dom";
import { useGetCryptosQuery } from "../../services/cryptoAPI";
import {Cryptocurrencies, News} from "../../components";


const { Title } = Typography;

const HomePage = () => {
    const { data, isFetching } = useGetCryptosQuery(10);

    const globalStats = data?.data?.stats;

    if (isFetching) return "Loading...";
    return (
        <>
            <Title level={2} className="heading">
                Global crypto stats
            </Title>
            <Row>
                <Col span={12}>
                    <Statistic
                        title="Total Crypto Currencies"
                        value={globalStats?.total}
                    />
                </Col>
                <Col span={12}>
                    <Statistic
                        title="Total Exchanges"
                        value={millify(globalStats?.totalExchanges, {
                            precision: 3,
                            lowercase: true,
                        })}
                    />
                </Col>
                <Col span={12}>
                    <Statistic
                        title="Total Market Cap"
                        value={millify(globalStats?.totalMarketCap, {
                            precision: 3,
                            lowercase: true,
                        })}
                    />
                </Col>
                <Col span={12}>
                    <Statistic
                        title="Total 24h Volume"
                        value={millify(globalStats?.total24hVolume, {
                            precision: 3,
                            lowercase: true,
                        })}
                    />
                </Col>
                <Col span={12}>
                    <Statistic
                        title="Total Markets"
                        value={millify(globalStats?.totalMarkets, {
                            precision: 3,
                            lowercase: true,
                        })}
                    />
                </Col>
            </Row>
            <div className="home-heading-container">
                <Title level={2} className="home-title">
                    Top 10 Cryptocurrencies in the world
                </Title>
                <Title level={2} className="show-more">
                    <Link to="/cryptocurrencies">
                        Show more
                    </Link>
                </Title>
            </div>
            <Cryptocurrencies simplified />
            <div className="home-heading-container">
                <Title level={2} className="home-title">
                    Latest Crypto News
                </Title>
                <Title level={2} className="show-more">
                    <Link to="/news">
                        Show more
                    </Link>
                </Title>
            </div>
            <News simplified />

        </>
    );
};

export default HomePage;
